/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignListEntryFromJSON, CampaignListEntryToJSON, } from './CampaignListEntry';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfCampaignListEntry interface.
 */
export function instanceOfPagedResponseOfCampaignListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfCampaignListEntryFromJSON(json) {
    return PagedResponseOfCampaignListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfCampaignListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(CampaignListEntryFromJSON)),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage'])
    };
}
export function PagedResponseOfCampaignListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'page': value.page,
        'size': value.size,
        'numberOfElements': value.numberOfElements,
        'nextPage': PageRequestToJSON(value.nextPage),
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(CampaignListEntryToJSON)),
        'hasPrevious': value.hasPrevious,
        'metaData': MetaDataToJSON(value.metaData),
        'hasNext': value.hasNext,
        'previousPage': PageRequestToJSON(value.previousPage)
    };
}
